import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import config from '../../../app/config';
import { color } from '../../../app/theme';
import IcAlert from '../../../assets/images/svg/ic_alert.svg';
import { checkGa4EventDomain } from '../../../features/mainSlice';

const useStyles = makeStyles(
  {
    tip: {
      display: 'flex',
      alignItems: 'start',
      padding: '13px 16px',
      background: 'rgba(241, 192, 54, 0.10)',
      borderRadius: 4,
      marginBottom: 12,
      '& > img': {
        marginRight: 12,
      },
      '& a': {
        fontWeight: '400',
        fontSize: '15px',
        lineHeight: '21px',
        color: color.$18,
        textDecoration: 'underline',
      },
      '& > div, a': {
        fontWeight: '400',
        fontSize: '15px',
        lineHeight: '21px',
        color: color.$18,
      },
    },
  },
  {
    name: 'GATip',
  },
);

const GATip = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { objectId, ga4EventDomain } = useSelector(store => store.organization);
  const { data } = useSelector(store => store.ma);
  const { platform, nodes } = data || {};

  const isGa4EventVerify = checkGa4EventDomain(platform, ga4EventDomain, nodes);

  if (isGa4EventVerify) {
    return null;
  }

  return (
    <div>
      <div className={classes.tip}>
        <img src={IcAlert} alt="alert" />
        <div>
          <div style={{ fontWeight: '500' }}>{t('platformTipTitle')}</div>
          {t('connectGATip')}
          <a
            href={`${config.CONSOLE_URL}/superMarket/${objectId}/ga4Event`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('connectGA')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default GATip;
